import { render, staticRenderFns } from "./v-chat-print-timestamp.vue?vue&type=template&id=055f5cbd&scoped=true&"
var script = {}
import style0 from "./v-chat-print-timestamp.vue?vue&type=style&index=0&id=055f5cbd&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "055f5cbd",
  null
  
)

export default component.exports